import React, {Component} from 'react';
import {Button, PriorityIcon} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {Column} from '../../Form/serializers/column';
import {ColumnsSearch} from './ColumnSearch';

@observer
export class AddField extends Component<any, {showDropdown}> {
    constructor(props) {
        super(props);
        this.state = {showDropdown: false};
    }

    addFilter = item => {
        const {selectedSearch} = this.props;
        selectedSearch.addFilter(item);
        this.setState({showDropdown: false});
    };

    showDropdown = () => {
        this.setState({showDropdown: true});
    };

    showButton = () => {
        const {selectedSearch} = this.props;
        if (selectedSearch.filters.size > 0 && this.state.showDropdown) {
            this.setState({showDropdown: false});
        }
    };

    render() {
        const {selectedSearch, currentForm, autoFocus = true} = this.props;
        const isEmptySearch = selectedSearch.filters.size === 0;
        return isEmptySearch || this.state.showDropdown ? (
            <ColumnsSearch
                openOnFocus
                className="select-field"
                dropdown
                inputProps={{
                    autoFocus: autoFocus,
                    size: 'large',
                    width: 'fullWidth',
                    placeholder: getLocalizedText(texts.selectFieldPlaceholder)
                }}
                keyToSearch="title"
                closeOnSelect={false}
                options={
                    currentForm.isRecon
                        ? currentForm.visibleColumns.filter(
                              c => c.name.startsWith('FRST_') || c.name.startsWith('SCND_')
                          )
                        : currentForm.visibleColumns
                }
                handleClickOutside={this.showButton}
                isOptionDisabled={(option: Column) => {
                    return selectedSearch.filteredColumns.indexOf(option.field) > -1;
                }}
                onSelect={this.addFilter}
                listProps={{autoHeightMax: isEmptySearch ? 46 * 10 : 46 * 6}}
            />
        ) : (
            <Button
                skin="secondary"
                icon={PriorityIcon.add}
                size="large"
                width="fullWidth"
                componentClasses="add-field-button"
                onClick={this.showDropdown}
            >
                {getLocalizedText(texts.newField)}
            </Button>
        );
    }
}
